import { Navigation, NavigationItem, TopBar } from "@hm-group/bads-react";
import "./TopBarHeader.scss";
import { NavigationTabs } from "../../constants/constants";

interface TopBarHeaderProps {
  activeTab: NavigationTabs;
  onTabChange?: (tab: NavigationTabs) => void;
}

const TopBarHeader = ({ activeTab, onTabChange }: TopBarHeaderProps) => {
  return (
    <TopBar sticky testId="top-bar">
      <div className="top-bar-header">
        <div className="top-bar-title">Assortment Taxonomy</div>
        <div className="vertical-separator" />
        <Navigation
          value={activeTab}
          onChange={(val: string) => {
            if (onTabChange) {
              onTabChange(val as NavigationTabs);
            }
          }}
        >
          <NavigationItem value={NavigationTabs.ProductTaxonomy} label="Product taxonomy" />
          <NavigationItem value={NavigationTabs.AdditionalProductInfo} label="Additional product information" />
        </Navigation>
      </div>
    </TopBar>
  );
};

export default TopBarHeader;
